import React, { useEffect } from 'react'
import styles from './Logo.module.css'
import { LogoProjectGalleryInterface } from '../../../../../../../lib/types/logoProjectGallery';
import { urlFor } from '../../../../../../../lib/sanity.client';

export type LogoProps = {
    logoPG: LogoProjectGalleryInterface | null;
}

const Logo = (props: LogoProps) => {

    const [type, setType] = React.useState<string>('normal');

    useEffect(() => {
        if (props.logoPG?.images && props.logoPG.images.length > 1) {
            setType('multiple');
        }
    }, [props.logoPG]);

    return (
        <>
        {props.logoPG && 
            <div className={styles.container}>
                <div className={`${type === 'normal' ? styles.normal : styles.multiple}`}>
                    {props.logoPG.images.map((image, index) => (
                        <img key={index} src={urlFor(image).url()} alt={`Logo ${index + 1}`} />
                    ))}
                </div>
            </div>
        }
        </>
    )
}

export default Logo;